module.exports = __webpack_public_path__ + "static/img/limao.b7181ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/limao.png
// module id = cRXe
// module chunks = 0